import { getBrandName } from '../locale';
import { HmcUrlBuilderParams, SprykerUrlBuilderParams } from '../types/replatform/endpoints.types';

export class UrlBuilder {
  static buildSprykerURL(parameters: SprykerUrlBuilderParams): string {
    const { host = '',
      endPointName,
      brand = '',
      countryCode = '',
      languageCode,
      queryParams = {},
    } = parameters;
    const url = `${host}${endPointName}?${new URLSearchParams({
      brand: brand || getBrandName(),
      'country-code': countryCode,
      'language-code': languageCode,
      ...queryParams,
    })}`;
    return url;
  }

  static buildHmcURL(parameters: HmcUrlBuilderParams): string {
    const { host = '',
      endPointName,
      countryCode = '',
      languageCode,
      resources = '',
      queryParams = {},
    } = parameters;
    const searchParams = new URLSearchParams(queryParams).toString();
    const urlQueryParams = searchParams ? `?${searchParams}` : '';
    return `${host}${endPointName}/${countryCode}/${languageCode}${resources}${urlQueryParams}`;
  }
}
